module.exports = __webpack_public_path__ + "img/l9.6590fb6d.png";